export default __webpack_public_path__ + "static/astronaut-5ba6393dbba1b10f0c55651a04b1da47.png";